import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NavbarForOnboardingForm from "../onboarding/NavbarForOnbardingForm";

function AddUser() {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [organization, setOrganization] = useState("");
  const [designation, setDesignation] = useState("");
  const [role, setRole] = useState("");
  const [userType, setUserType] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    // Retrieve client ID and user ID from localStorage
    const storedClient = localStorage.getItem("client");

    const client_id = storedClient ? Number(storedClient) : null;

    // Debugging: Log retrieved values
    // console.log("client id:", { client_id });

    if (!client_id) {
      alert("Client ID is missing. Please log in again.");
      return;
    }

    const apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/auth/admin-create-user/`; // Local Django server endpoint
    const headers = {
      "Content-Type": "application/json",
    };

    const data = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone_number: phone,
      organization,
      designation,
      role,
      client: client_id,
      user_type: userType,
    };
    // console.log("Request data:", data);
    axios
      .post(apiEndpoint, data, { headers })
      .then((response) => {
        // console.log(response.data);
        navigate("/user_confirmation");
      })
      .catch((error) => {
        // Check if the error response contains a message from the backend
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          alert(error.response.data.message);
        } else {
          alert("Failed to Add User");
        }
        console.error(error);
      });
  };
  return (
    <>
      <NavbarForOnboardingForm />
      <div className="container py-4 mt-5">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-10 col-md-8 col-lg-6 col-xl-5 log">
            <div className="card border border-dark bg-transparent text-white">
              <div
                className="card-header border-dark"
                style={{ background: "#008cba" }}
              >
                <h3 className="text-center font_header">Add User Form</h3>
              </div>
              <div className="card-body text-dark">
                <form onSubmit={handleSubmit}>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <div data-mdb-input-init className="form-outline">
                          <label className="form-label" htmlFor="firstName">
                            First Name
                          </label>
                          <input
                            type="text"
                            id="firstName"
                            className="form-control border-dark text-dark"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div data-mdb-input-init className="form-outline">
                          <label className="form-label" htmlFor="lastName">
                            Last Name
                          </label>
                          <input
                            type="text"
                            id="lastName"
                            className="form-control border-dark text-dark"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="email" className="form-label">
                          Email address
                        </label>
                        <input
                          type="email"
                          className="form-control border-dark text-dark"
                          id="email"
                          aria-describedby="emailHelp"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="phone" className="form-label">
                          Phone Number
                        </label>
                        <input
                          type="tel"
                          className="form-control border-dark text-dark"
                          id="phone"
                          aria-describedby="emailHelp"
                          pattern="(\+91)?[6-9][0-9]{9}"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="organization" className="form-label">
                          Organization
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="organization"
                          aria-describedby="emailHelp"
                          value={organization}
                          onChange={(e) => setOrganization(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="designation" className="form-label">
                          Designation
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="designation"
                          aria-describedby="emailHelp"
                          value={designation}
                          onChange={(e) => setDesignation(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <label htmlFor="role" className="form-label">
                      Role
                    </label>
                    <input
                      type="text"
                      className="form-control border-dark text-dark"
                      id="role"
                      aria-describedby="emailHelp"
                      value={role}
                      onChange={(e) => setRole(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">User Type</label>
                    <div className="row">
                      {/* First Row */}
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="admin"
                            name="userType"
                            value="admin"
                            className="form-check-input border-dark"
                            onChange={(e) =>
                              setUserType(e.target.value.toLowerCase())
                            }
                            required
                          />
                          <label className="form-check-label" htmlFor="admin">
                            Admin
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="hr"
                            name="userType"
                            value="hr"
                            className="form-check-input border-dark"
                            onChange={(e) =>
                              setUserType(e.target.value.toLowerCase())
                            }
                            required
                          />
                          <label className="form-check-label" htmlFor="hr">
                            HR
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      {/* Second Row */}
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="manager"
                            name="userType"
                            value="manager"
                            className="form-check-input border-dark"
                            onChange={(e) =>
                              setUserType(e.target.value.toLowerCase())
                            }
                            required
                          />
                          <label className="form-check-label" htmlFor="manager">
                            Manager
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="recruiter"
                            name="userType"
                            value="recruiter"
                            className="form-check-input border-dark"
                            onChange={(e) =>
                              setUserType(e.target.value.toLowerCase())
                            }
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="recruiter"
                          >
                            Recruiter
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center py-2">
                    <button type="submit" className="btn me-2 btn-outline-info">
                      Add User
                    </button>
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      onClick={() => (window.location.href = "/user_dashboard")}
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddUser;
